class ColourSwatches extends window.BAO.CustomElement() {
  connectedCallback() {
    this.activeSwapImage = null
    this.imageContainerEl = this.getImageContainerEl()

    if (!this.imageContainerEl) return

    this.setupListeners()
  }

  getImageContainerEl() {
    if (!this.cardEl) return

    const container = this.cardEl.querySelector('[data-colour-swatches-external-el="image-container"]')

    if (!container) return

    return container
  }

  setupListeners() {
    this.handleSwatchEnter = this.handleSwatchEnter.bind(this)
    this.handleSwatchLeave = this.handleSwatchLeave.bind(this)

    this.querySelectorAll('[data-colour-swatches-el="swatch"]').forEach((swatch) => {
      this.listeners.add(swatch, 'mouseenter', this.handleSwatchEnter)
      this.listeners.add(swatch, 'mouseleave', this.handleSwatchLeave)
    })
  }

  handleSwatchEnter(event) {
    const swatchIndex = event.currentTarget.closest('[data-colour-swatches-el="swatch"]').dataset.swatchIndex
    const template = this.querySelector(`[data-colour-swatches-el="image-template-${swatchIndex}"]`)

    if (!template) return

    this.swapImage(template)
  }

  handleSwatchLeave() {
    this.removeSwapImage()
  }

  swapImage(template) {
    if (this.activeSwapImage) {
      this.activeSwapImage.replaceWith(template.content.cloneNode(true).firstElementChild)
      this.activeSwapImage = this.imageContainerEl.lastElementChild
      this.cardEl.dataset.swatchHoverActive = 'true'

      return
    }

    const wrapper = template.content.cloneNode(true).firstElementChild

    this.imageContainerEl.appendChild(wrapper)
    this.activeSwapImage = wrapper
    this.cardEl.dataset.swatchHoverActive = 'true'
  }

  removeSwapImage() {
    const wrapper = this.activeSwapImage

    if (!wrapper) return

    this.cardEl.dataset.swatchHoverActive = 'false'

    wrapper.addEventListener('transitionend', () => {
      wrapper.remove()
      this.activeSwapImage = null
    }, { once: true })
  }

  get cardEl() {
    return this.closest('[data-colour-swatches-external-el="product-card"]')
  }
}

if (!customElements.get('colour-swatches')) {
  customElements.define('colour-swatches', ColourSwatches)
}
